import { render, staticRenderFns } from "./activity-notulen-attendant.vue?vue&type=template&id=772c0991"
import script from "./activity-notulen-attendant.vue?vue&type=script&lang=js"
export * from "./activity-notulen-attendant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports